<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <CardIeaApp colorCard="#A7BA38" title="Inscripción">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row align="center" v-if="formulario == 'BCE Secundario Argentina'">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="mostrarPanelMenor">
                <v-alert border="top" colored-border type="info" elevation="0">
                  Al finalizar la inscripción por favor ponerse en contacto con
                  administración
                </v-alert>
              </v-col>

              <!-- usuario -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>

              <!-- email -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-n9">
                <InputCustom :inputProp="inputs[1]" />
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-alert dense type="warning">
                  La contraseña la podrá especificar la primera vez que ingrese
                  al sistema.
                </v-alert>
              </v-col>

              <!-- nombre -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[2]" />
              </v-col>

              <!-- apellido -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[3]" />
              </v-col>

              <!-- fecha nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[4]" />
              </v-col>

              <!-- Nacionalidad -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[42]" />
              </v-col>

              <!-- tipo doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[5]" />
              </v-col>

              <!-- doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[6]" />
              </v-col>

              <!-- genero -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[7]" />
              </v-col>

              <!-- localidad -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[8]" />
              </v-col>


              <!-- direccion -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[9]" />
              </v-col>
              <!-- pais Nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[44]" />
              </v-col>
              <!-- area celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[12]" />
              </v-col>

              <!-- telefono celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[13]" />
              </v-col>

              <!-- turno -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[15]" />
              </v-col>

              <!-- turno inscpcion -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[16]" />
              </v-col>

              <!-- año -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[17]" />
              </v-col>

              <!-- curso -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[18]" />
              </v-col>

              <!-- colegio -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[19]" />
              </v-col>

              <!-- titulo -->
              <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                <InputCustom :inputProp="inputs[20]" />
              </v-col>

              <!-- nombre emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[23]" />
              </v-col>

              <!-- relacion emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[24]" />
              </v-col>

              <!-- numero emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[25]" />
              </v-col>

              <!-- nombre emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[26]" />
              </v-col>

              <!-- relacion emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[27]" />
              </v-col>

              <!-- numero emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[28]" />
              </v-col>

              <!-- efermedades -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[29]" />
              </v-col>

              <!-- operaciones  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[30]" />
              </v-col>

              <!-- operaciones cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[30].value == 'SI'">
                <InputCustom :inputProp="inputs[31]" />
              </v-col>

              <!-- enfermedad infecciosa  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[32]" />
              </v-col>

              <!-- enfermedad infecciosa cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[32].value == 'SI'">
                <InputCustom :inputProp="inputs[33]" />
              </v-col>

              <!-- alergia  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[34]" />
              </v-col>

              <!-- alergia cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[34].value == 'SI'">
                <InputCustom :inputProp="inputs[35]" />
              </v-col>

              <!-- tipo sangre  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[36]" />
              </v-col>

              <!-- tratamiento psicologico  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[37]" />
              </v-col>

              <!-- añadir a bolsa de trabajo  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[38]" />
              </v-col>

              <!-- añadir a bolsa de trabajo disponibilidad  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[39]" />
              </v-col>

              <!-- añadir a bolsa de trabajo zona  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[40]" />
              </v-col>

              <!-- añadir a bolsa de trabajo persona que...  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[41]" />
              </v-col>

            </v-row>

            <v-row v-else-if="formulario == 'BCE Secundario Exterior'">

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="mostrarPanelMenor">
                <v-alert border="top" colored-border type="info" elevation="0">
                  Al finalizar la inscripción por favor ponerse en contacto con
                  administración
                </v-alert>
              </v-col>

              <!-- usuario -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>

              <!-- email -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-n9">
                <InputCustom :inputProp="inputs[1]" />
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-alert dense type="warning">
                  La contraseña la podrá especificar la primera vez que ingrese
                  al sistema.
                </v-alert>
              </v-col>

              <!-- nombre -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[2]" />
              </v-col>

              <!-- apellido -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[3]" />
              </v-col>

              <!-- fecha nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[4]" />
              </v-col>


              <!-- tipo doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[5]" />
              </v-col>

              <!-- doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[6]" />
              </v-col>

              <!-- genero -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[7]" />
              </v-col>

              <!-- Nacionalidad -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[42]" />
              </v-col>

              <!-- Pais de Residencia  -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[43]" />
              </v-col>

              <!-- Localidad  -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[8]" />
              </v-col>

              <!-- direccion -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[9]" />
              </v-col>

              <!-- pais Nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[44]" />
              </v-col>
              <!-- area celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[12]" />
              </v-col>

              <!-- telefono celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[13]" />
              </v-col>

              <!-- turno -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[15]" />
              </v-col>

              <!-- turno inscpcion -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[16]" />
              </v-col>

              <!-- año -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[17]" />
              </v-col>

              <!-- curso -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[18]" />
              </v-col>

              <!-- colegio -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[19]" />
              </v-col>

              <!-- titulo -->
              <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                <InputCustom :inputProp="inputs[20]" />
              </v-col>

              <!-- nombre emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[23]" />
              </v-col>

              <!-- relacion emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[24]" />
              </v-col>

              <!-- numero emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[25]" />
              </v-col>

              <!-- nombre emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[26]" />
              </v-col>

              <!-- relacion emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[27]" />
              </v-col>

              <!-- numero emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[28]" />
              </v-col>

              <!-- efermedades -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[29]" />
              </v-col>

              <!-- operaciones  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[30]" />
              </v-col>

              <!-- operaciones cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[30].value == 'SI'">
                <InputCustom :inputProp="inputs[31]" />
              </v-col>

              <!-- enfermedad infecciosa  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[32]" />
              </v-col>

              <!-- enfermedad infecciosa cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[32].value == 'SI'">
                <InputCustom :inputProp="inputs[33]" />
              </v-col>

              <!-- alergia  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[34]" />
              </v-col>

              <!-- alergia cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[34].value == 'SI'">
                <InputCustom :inputProp="inputs[35]" />
              </v-col>

              <!-- tipo sangre  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[36]" />
              </v-col>

              <!-- tratamiento psicologico  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[37]" />
              </v-col>

              <!-- añadir a bolsa de trabajo  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[38]" />
              </v-col>

              <!-- añadir a bolsa de trabajo disponibilidad  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[39]" />
              </v-col>

              <!-- añadir a bolsa de trabajo zona  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[40]" />
              </v-col>

              <!-- añadir a bolsa de trabajo persona que...  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[41]" />
              </v-col>

            </v-row>

            <v-row v-else-if="formulario == 'Cursos Online Argentina' || formulario == 'Cursos Online Exterior'">

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="mostrarPanelMenor">
                <v-alert border="top" colored-border type="info" elevation="0">
                  Al finalizar la inscripción por favor ponerse en contacto con
                  administración
                </v-alert>
              </v-col>

              <!-- usuario -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>

              <!-- email -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-n9">
                <InputCustom :inputProp="inputs[1]" />
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="mostrarPanelMenor">
                <v-alert border="top" colored-border type="info" elevation="0">
                  Al finalizar la inscripción por favor ponerse en contacto con
                  administración
                </v-alert>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-alert dense type="warning">
                  La contraseña la podrá especificar la primera vez que ingrese
                  al sistema.
                </v-alert>
              </v-col>

              <!-- nombre -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[2]" />
              </v-col>

              <!-- apellido -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[3]" />
              </v-col>

              <!-- fecha nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[4]" />
              </v-col>


              <!-- tipo doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[5]" />
              </v-col>

              <!-- doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[6]" />
              </v-col>

              <!-- genero -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[7]" />
              </v-col>

              <!-- Nacionalidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[42]" />
              </v-col>

              <!-- localidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[8]" />
              </v-col>

              <!-- pais Nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[44]" />
              </v-col>
              <!-- direccion -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[9]" />
              </v-col>

              <!-- area celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[12]" />
              </v-col>

              <!-- telefono celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[13]" />
              </v-col>

              <!-- turno -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[15]" />
              </v-col>

              <!-- turno inscpcion -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[16]" />
              </v-col>

              <!-- año -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[17]" />
              </v-col>

              <!-- curso -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[18]" />
              </v-col>


            </v-row>

            <v-row v-if="formulario == 'Carreras Terciarias Exterior' || formulario == 'Inscripcion'">

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="mostrarPanelMenor">
                <v-alert border="top" colored-border type="info" elevation="0">
                  Al finalizar la inscripción por favor ponerse en contacto con
                  administración
                </v-alert>
              </v-col>

              <!-- usuario -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>

              <!-- email -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-n9">
                <InputCustom :inputProp="inputs[1]" />
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-alert dense type="warning">
                  La contraseña la podrá especificar la primera vez que ingrese
                  al sistema.
                </v-alert>
              </v-col>

              <!-- nombre -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[2]" />
              </v-col>

              <!-- apellido -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[3]" />
              </v-col>

              <!-- fecha nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[4]" />
              </v-col>

              <!-- tipo doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[5]" />
              </v-col>

              <!-- doc -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[6]" />
              </v-col>

              <!-- Nacionalidad -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[42]" />
              </v-col>

              <!-- Pais de Residencia  -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[43]" />
              </v-col>

              <!-- genero -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[7]" />
              </v-col>

              <!-- localidad -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[8]" />
              </v-col>

              <!-- direccion -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[9]" />
              </v-col>
              <!-- Pais de Nacimiento -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[44]" />
              </v-col>

              <!-- area fijo -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[10]" />
              </v-col>

              <!-- telefono fijo -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[11]" />
              </v-col>

              <!-- area celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[12]" />
              </v-col>

              <!-- telefono celular -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[13]" />
              </v-col>

              <!-- sede -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[14]" v-on:change="item => {
                  test(item);
                }
                  " />
              </v-col>

              <!-- turno -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[15]" />
              </v-col>

              <!-- turno inscpcion -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[16]" />
              </v-col>

              <!-- año -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[17]" />
              </v-col>

              <!-- curso -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[18]" />
              </v-col>

              <!-- colegio -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[19]" />
              </v-col>

              <!-- titulo -->
              <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                <InputCustom :inputProp="inputs[20]" />
              </v-col>

              <!-- adeuda materia -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[21]" />
              </v-col>

              <!-- cantidad -->
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" v-if="inputs[21].value == 'SI'">
                <InputCustom :inputProp="inputs[22]" />
              </v-col>

              <!-- nombre emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[23]" />
              </v-col>

              <!-- relacion emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[24]" />
              </v-col>

              <!-- numero emergencia 1 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[25]" />
              </v-col>

              <!-- nombre emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[26]" />
              </v-col>

              <!-- relacion emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[27]" />
              </v-col>

              <!-- numero emergencia 2 -->
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <InputCustom :inputProp="inputs[28]" />
              </v-col>

              <!-- efermedades -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[29]" />
              </v-col>

              <!-- operaciones  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[30]" />
              </v-col>

              <!-- operaciones cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[30].value == 'SI'">
                <InputCustom :inputProp="inputs[31]" />
              </v-col>

              <!-- enfermedad infecciosa  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[32]" />
              </v-col>

              <!-- enfermedad infecciosa cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[32].value == 'SI'">
                <InputCustom :inputProp="inputs[33]" />
              </v-col>

              <!-- alergia  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[34]" />
              </v-col>

              <!-- alergia cantidad -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[34].value == 'SI'">
                <InputCustom :inputProp="inputs[35]" />
              </v-col>

              <!-- tipo sangre  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[36]" />
              </v-col>

              <!-- tratamiento psicologico  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[37]" />
              </v-col>

              <!-- añadir a bolsa de trabajo  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <InputCustom :inputProp="inputs[38]" />
              </v-col>

              <!-- añadir a bolsa de trabajo disponibilidad  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[39]" />
              </v-col>

              <!-- añadir a bolsa de trabajo zona  -->
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[40]" />
              </v-col>

              <!-- añadir a bolsa de trabajo persona que...  -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="inputs[38].value == 'SI'">
                <InputCustom :inputProp="inputs[41]" />
              </v-col>

            </v-row>

          </v-form>
        </CardIeaApp>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <v-btn @click="store()" block x-large class="white--text rounded-lg font-weight-regular" depressed
          color="btnSuccess" :disabled="!valid" :loading="loader">Aceptar</v-btn>
      </v-col>
      <br /><br /><br /><br /><br />
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"></v-col>
      <DebugModal :data="$data" />
    </CardIeaAppMain>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline" style="color: white;background-color: green;">
          Atención
        </v-card-title>

        <v-card-text class="mt-2">
          La inscripción se ha realizado con éxito.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="finish()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- modal para notoficar campos vacios en form -->
    <v-dialog v-model="dialogWarning" width="500" persistent>
      <v-card>
        <v-card-title class="headline" style="color: white;background-color: orange;">
          Atención
        </v-card-title>

        <v-card-text class="mt-2">
          Falta completar campos, revise el formulario.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click.stop="aceptarDialogWarinig()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import CardIeaApp from "../../components/CardIeaApp";
import InputCustom from "../../components/InputCustom";
import DebugModal from "../../components/DebugModal";
import MessagesRules from "../../config/MessagesRules";
import efermedades from "../../config/Enfermedades";
// import TitulosSecundaria from "../../config/TitulosSecundaria";
// import Localidad from "../../config/Localidad";
import countries from "../../config/Paises";
import moment from "moment";
export default {
  name: "Inscripcion",
  components: {
    CardIeaAppMain,
    CardIeaApp,
    InputCustom,
    DebugModal
  },
  mounted() {
    this.loadInitial();
    // debugger;
    this.fechaActual = moment();
    this.yearNow = moment().format('YYYY');
    this.nextYear = moment().add(1, 'years').format('YYYY');
    this.years = [this.yearNow, this.nextYear];
    // debugger;
  },
  watch: {
    inputs: {
      handler() {
        let datos = this.inputs[4].value;
        if (datos != "" && this.fechaActual != "") {
          let nacimiento = moment(datos);
          let diff = this.fechaActual.diff(nacimiento, "months");
          if (diff <= 210) {
            this.mostrarPanelMenor = true;
          } else {
            this.mostrarPanelMenor = false;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    loader() {
      return this.$store.getters.loader;
    }
  },
  data: () => ({
    fechaActual: "",
    years: "",
    mostrarPanelMenor: false,
    dialog: false,
    dialogWarning: false,
    url: "",
    valid: true,
    loading: false,
    inputs: [
      {
        tag: "usuario",
        text: "Usuario (ESTE SERÁ SU USUARIO PARA INGRESAR AL SISTEMA)",
        placeholder: "Ejem: juan201384 / 6846maria / david_s0ut",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Usuario" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "email",
        text: "Email",
        placeholder: "ejemplo@ejemplo.com",
        icon: "mdi-email",
        required: true,
        value: "",
        type: "email",
        rules: [
          v => !!v || "Email" + MessagesRules.required,
          v => /.+@.+\..+/.test(v) || MessagesRules.email
        ],
        counter: 0
      },
      {
        tag: "nombre",
        text: "Nombre",
        placeholder: "Pedro",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Nombre" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "apellido",
        text: "Apellido",
        placeholder: "Perez",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Apellido" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "fechaNacimiento",
        text: "Fecha de nacimiento *",
        placeholder: "dd/mm/YYYY",
        icon: "mdi-calendar",
        required: true,
        value: "",
        type: "date",
        rules: [v => !!v || "Fecha de nacimiento " + MessagesRules.required],
        counter: 0,
        config: {
          view: false
        }
      },
      {
        tag: "tipoDocumento",
        text: "Tipo de documento",
        placeholder: "",
        icon: "mdi-account-box-multiple",
        required: true,
        value: 1,
        type: "select",
        rules: [v => !!v || "Tipo de documento" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "DNI", value: 1 },
          { text: "PASAPORTE", value: 2 }
        ]
      },
      {
        tag: "documento",
        text: "Documento",
        placeholder: "########",
        icon: "mdi-card-account-details",
        required: true,
        value: "",
        type: "DNI",
        mask: "########",
        rules: [v => !!v || "Documento" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "sexo",
        text: "Sexo *",
        placeholder: "",
        icon: "mdi-gender-male-female-variant",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Sexo" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "Masculino", value: "Masculino" },
          { text: "Femenino", value: "Femenino" },
          { text: "X", value: "X" },
          { text: "Otro", value: "Otro" }
        ]
      },
      // {
      //   tag: "localidad",
      //   text: "Localidad *",
      //   placeholder: "",
      //   icon: "mdi-map-marker",
      //   required: true,
      //   value: "",
      //   type: "select",
      //   mask: "",
      //   rules: [v => !!v || "Localidad" + MessagesRules.required],
      //   counter: 0,
      //   data: Localidad
      // },
      {
        tag: "localidad",
        text: "Localidad *",
        placeholder: "Ingrese Localidad",
        icon: "mdi-map-marker",
        required: true,
        value: "",
        type: "text",
        mask: "",
        rules: [v => !!v || "Localidad" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "direccion",
        text: "Dirección *",
        placeholder: "Ingrese la dirección",
        icon: "mdi-map-marker",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Dirección" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "areaFijo",
        text: "N° Área teléfono fijo",
        placeholder: "####",
        icon: "mdi-deskphone",
        required: false,
        value: "",
        type: "number",
        mask: "####",
        rules: [],
        counter: 0
      },
      {
        tag: "telefonoFijo",
        text: "N° Teléfono fijo",
        placeholder: "########",
        icon: "mdi-deskphone",
        required: false,
        value: "",
        type: "number",
        mask: "########",
        rules: [],
        counter: 0
      },
      {
        tag: "areaCelular",
        text: "N° Área celular - móvil",
        placeholder: "####",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "####",
        rules: [v => !!v || "Area" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "telefonoCelular",
        text: "Celular - móvil",
        placeholder: "########",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "########",
        rules: [v => !!v || "Telefono" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "sede",
        text: "Sede de inicio",
        placeholder: "",
        icon: "mdi-map-marker",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Sede" + MessagesRules.required],
        counter: 0,
        data: []
      },
      // 15
      {
        tag: "turnoMes",
        text: "Turno de inicio",
        placeholder: "",
        icon: "mdi-calendar",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Turno" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "Marzo", value: "1" },
          { text: "Agosto", value: "8" },
          { text: "Mayo", value: "9" },
          { text: "Octubre", value: "10" }
        ]
      },
      // 16
      {
        tag: "turnoTiempo",
        text: "Turno de inscripción",
        placeholder: "",
        icon: "mdi-clock-time-eleven",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Turno" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "Mañana", value: 1 },
          { text: "Noche", value: 2 },
          { text: "Sabados", value: 3 }
        ]
      },
      // 17
      {
        tag: "year",
        text: "Año de Comienzo",
        placeholder: "",
        icon: "mdi-calendar",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Año" + MessagesRules.required],
        counter: 0,
        data: []
      },

      //18
      {
        tag: "curso",
        text: "Carrera de interés",
        placeholder: "",
        icon: "mdi-book",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Carrera" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "Masculino", value: 1 },
          { text: "Femenino", value: 2 },
          { text: "Otro", value: 3 }
        ]
      },

      //19
      {
        tag: "secundaria",
        text: "Colegio secundario *",
        placeholder: "Ingrese el colegio secundario",
        icon: "mdi-food-apple",
        required: true,
        value: "",
        type: "text",
        mask: "",
        rules: [v => !!v || "Colegio" + MessagesRules.required],
        counter: 0
      },

      //20
      // {
      //   tag: "titulo",
      //   text: "Título secundario *",
      //   placeholder: "",
      //   icon: "mdi-bookshelf",
      //   required: true,
      //   value: "",
      //   type: "select",
      //   mask: "",
      //   rules: [v => !!v || "Titulo" + MessagesRules.required],
      //   counter: 0,
      //   data: TitulosSecundaria
      // },
      {
        tag: "titulo",
        text: "Título secundario *",
        placeholder: "Título secundario",
        icon: "mdi-bookshelf",
        required: true,
        value: "",
        type: "text",
        mask: "",
        rules: [v => !!v || "Titulo" + MessagesRules.required],
        counter: 0
      },
      //21
      {
        tag: "adeudaMateria",
        text: "Adeuda materia",
        placeholder: "",
        icon: "mdi-bookmark-off",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Adeuda materia" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "SI", value: "SI" },
          { text: "NO", value: "NO" }
        ]
      },

      //22
      {
        tag: "adeudaMateriaCantidad",
        text: "¿ Cuantas materias adeuda ?",
        placeholder: "1",
        icon: "mdi-bookmark-off",
        required: true,
        value: "",
        type: "number",
        mask: "##",
        rules: [
          v => !!v || "Cantidad" + MessagesRules.required,
          v => v > 0 || MessagesRules.min + "0"
        ],
        counter: 0,
        min: 1
      },

      //23
      {
        tag: "nombreContacto1",
        text: "Nombre y apellido contacto de emergencia 1 *",
        placeholder: "Ingrese contacto de emergencia",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        mask: "",
        rules: [v => !!v || "Nombre y apellido" + MessagesRules.required],
        counter: 0
      },

      //24
      {
        tag: "relacionContacto1",
        text: "Relación contacto de emergencia 1 *",
        placeholder: "Ingrese la relación del contacto de emergencia",
        icon: "mdi-account-group",
        required: true,
        value: "",
        type: "text",
        mask: "",
        rules: [v => !!v || "Relación" + MessagesRules.required],
        counter: 0
      },

      //25
      {
        tag: "telefonoContacto1",
        text: "N° de teléfono contacto de emergencia 1 *",
        placeholder: "Ingrese el N° de teléfono contacto de emergencia",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "############",
        rules: [v => !!v || "Numero" + MessagesRules.required],
        counter: 0
      },

      //26
      {
        tag: "nombreContacto2",
        text: "Nombre y apellido contacto de emergencia 2 *",
        placeholder: "Ingrese otro contacto de emergencia",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        mask: "",
        rules: [v => !!v || "Nombre y apellido" + MessagesRules.required],
        counter: 0
      },

      //27
      {
        tag: "relacionContacto2",
        text: "Relación contacto de emergencia 2 *",
        placeholder: "Ingrese la relación del contacto de emergencia",
        icon: "mdi-account-group",
        required: true,
        value: "",
        type: "text",
        mask: "",
        rules: [v => !!v || "Relación" + MessagesRules.required],
        counter: 0
      },

      //28
      {
        tag: "telefonoContacto2",
        text: "N° de télefono contacto de emergencia 2 *",
        placeholder: "Ingrese el N° de teléfono contacto de emergencia",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "############",
        rules: [v => !!v || "Numero" + MessagesRules.required],
        counter: 0
      },

      //29
      {
        tag: "enfermedad",
        text: "Enfermedades",
        placeholder: "",
        icon: "mdi-virus",
        required: true,
        value: ["Ninguna"],
        type: "checkbox",
        multiple: true,
        mask: "",
        rules: [v => !!v || "Enfermedades" + MessagesRules.required],
        counter: 0,
        data: efermedades,
        config: {
          cols: 12,
          xs: 12,
          sm: 12,
          md: 4,
          lg: 4,
          xl: 4
        }
      },

      //30
      {
        tag: "operacion",
        text: "¿Ha sufrido alguna intervención quirúrgica?",
        placeholder: "",
        icon: "mdi-doctor",
        required: true,
        value: "NO",
        type: "select",
        mask: "",
        rules: [v => !!v || "intervención quirúrgica" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "SI", value: "SI" },
          { text: "NO", value: "NO" }
        ]
      },

      //31
      {
        tag: "operacionCantidad",
        text: "¿ Cual ?",
        placeholder: "Ingrese la intervención quirúrgica",
        icon: "mdi-counter",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Descripción de intervención quirúrgica" + MessagesRules.required],
        counter: 0,
        min: 1
      },

      //32
      {
        tag: "enfermedadInf",
        text: "¿Padece usted enf. infectocontagiosas?",
        placeholder: "",
        icon: "mdi-doctor",
        required: true,
        value: "NO",
        type: "select",
        mask: "",
        rules: [v => !!v || "enf. infectocontagiosas" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "SI", value: "SI" },
          { text: "NO", value: "NO" }
        ]
      },

      //33
      {
        tag: "enfermedadInfCantidad",
        text: "¿ Cuáles ?",
        placeholder: "Ingrese las enf. infectocontagiosas",
        icon: "mdi-counter",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Descripción de enf. infectocontagiosas" + MessagesRules.required],
        counter: 0,
        min: 1
      },

      //34
      {
        tag: "alergia",
        text: "¿Posee usted algún tipo de alergia?",
        placeholder: "",
        icon: "mdi-doctor",
        required: true,
        value: "NO",
        type: "select",
        mask: "",
        rules: [v => !!v || "alergia" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "SI", value: "SI" },
          { text: "NO", value: "NO" }
        ]
      },

      //35
      {
        tag: "alergiaCantidad",
        text: "¿ Cuales ?",
        placeholder: "Ingrese las alergias",
        icon: "mdi-counter",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Descripción de alergias" + MessagesRules.required],
        counter: 0,
        min: 1
      },

      //36
      {
        tag: "grupoSanguineo",
        text: "Grupo Sanguineo *",
        placeholder: "",
        icon: "mdi-doctor",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "Grupo Sanguineo" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "A+", value: "A+" },
          { text: "A-", value: "A-" },
          { text: "B+", value: "B+" },
          { text: "B-", value: "B-" },
          { text: "AB+", value: "AB+" },
          { text: "AB-", value: "AB-" },
          { text: "O+", value: "O+" },
          { text: "O-", value: "O-" },
          { text: "Otro", value: "Otro" }
        ]
      },


      //37
      {
        tag: "tratamientoPsicologico",
        text: "¿Se encuentra bajo tra. psicológico?",
        placeholder: "",
        icon: "mdi-doctor",
        required: true,
        value: "NO",
        type: "select",
        mask: "",
        rules: [v => !!v || "tratamiento psicológico" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "SI", value: "SI" },
          { text: "NO", value: "NO" }
        ]
      },


      //38
      {
        tag: "bolsaTrabajo",
        text:
          "¿Desea subir su perfil a la bolsa de trabajo para recibir ofertas? (no importa si no está buscando trabajo actualmente) *",
        placeholder: "",
        icon: "mdi-briefcase",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "El Campo" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "SI", value: "SI" },
          { text: "NO", value: "NO" }
        ]
      },

      //39
      {
        tag: "bolsaTrabajoDisponibilidad",
        text: "Disponibilidad",
        placeholder: "",
        icon: "mdi-account-clock",
        required: true,
        value: 1,
        type: "select",
        mask: "",
        rules: [v => !!v || "Disponibilidad" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "FULL TIME", value: 1 },
          { text: "PART TIME", value: 2 },
          { text: "FREELANCE", value: 3 }
        ]
      },

      //40
      {
        tag: "bolsaTrabajoZona",
        text: "Zona",
        placeholder: "",
        icon: "mdi-map-marker",
        required: true,
        value: 1,
        type: "select",
        mask: "",
        rules: [v => !!v || "Zona " + MessagesRules.required],
        counter: 0,
        data: [
          { text: "GBA NORTE", value: 1 },
          { text: "GBA OESTE", value: 2 },
          { text: "GBA SUR", value: 3 },
          { text: "CABA", value: 4 },
          { text: "OTROS", value: 5 }
        ]
      },

      //41
      {
        tag: "bolsaTrabajoOcupacion",
        text: "PERSONAS QUE...",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: [],
        type: "checkbox",
        multiple: true,
        mask: "",
        rules: [
          v => !!v || "El campo " + MessagesRules.required,
          v => v.length > 0 || "Se necesita por lo menos 1 opcion "
        ],
        counter: 0,
        data: [
          {
            text:
              "Pueden atender al Público Presencialmente (Ej: Vendedores en Locales, Recepcionistas, etc.) ",
            value: 1
          },
          {
            text:
              "Pueden atender al Público Telefónicamente (Ej: Telemarketing, Televentas, Call-Center, etc.)",
            value: 2
          },
          {
            text:
              "Administrar Documentos Rápidamente. (Ej: Empleados Administrativos, Secretarios, etc.)",
            value: 3
          },
          {
            text:
              "Dispongan de Movilidad en la Calle (Ej: Cadete, Chofer, etc.)",
            value: 4
          },
          {
            text:
              "Puedan Ejercer Trabajo Físico. (Ej: Operario, Obrero, Técnivos, etc.)",
            value: 5
          }
        ],
        config: {
          cols: 12,
          xs: 12,
          sm: 12,
          md: 4,
          lg: 4,
          xl: 4
        }
      },

      //42
      {
        tag: "nacionalidad",
        text: "Nacionalidad *",
        placeholder: "Ingrese la nacionalidad",
        icon: "",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Nacionalidad" + MessagesRules.required],
        counter: 0
      },

      //43
      {
        tag: "PaisResidencia",
        text: "País de Residencia *",
        placeholder: "Ingrese el país de residencia",
        icon: "",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "País de Residencia" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "PaisNacimiento",
        text: "Pais de Nacimiento *",
        placeholder: "",
        icon: "mdi-map-marker",
        required: true,
        value: "",
        type: "select",
        mask: "",
        rules: [v => !!v || "País de nacimiento" + MessagesRules.required],
        counter: 0,
        data: countries
      },
    ],
    tipoInscip: 0,
    datoAlumno: "",
    formulario: "",
    version: 0,
    makehash: '',
    prefix: '',
    timeValidate:''
  }),
  methods: {
    finish() {
      this.dialog = false;
      setTimeout(() => {
        if (this.version == 4) {
          this.$router.push({ name: 'ReviewPass', query: { makehash: this.makehash, prefix: this.prefix ,makehashprefix:this.timeValidate } });
          this.$store.dispatch("circuito", "");
          this.$store.dispatch("preinscrito", "");
          this.$store.dispatch("inscripto", "");
        } else {
          if (this.tipoInscip == 2) {
            // if (true) {
            this.$store.dispatch("inscripto", this.datoAlumno);
            this.$router.replace({ name: "Login" });
          } else {
            this.$store.dispatch("circuito", "");
            this.$store.dispatch("preinscrito", "");
            this.$store.dispatch("inscripto", "");
            window.location.href = this.url;
          }
        }

      }, 1000);
    },
    aceptarDialogWarinig() {
      this.dialogWarning = false;
    },
    store() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.inputs.preinscrito = {
          tag: "preinscrito",
          value: this.$route.params.preinscrito
        };

        this.inputs.circuito_uuid = {
          tag: "circuito_uuid",
          value: this.$route.params.id
        };

        this.loading = false;
        this.$API
          .post({
            url: "circuito/inscipcion",
            data: this.inputs,
            form: true
          })
          .then(res => {
            if (res.estado) {
              this.tipoInscip = res.tipo;
              this.datoAlumno = res.alumno;
              this.dialog = true;
              this.url = res.url;
              this.version = res.version
              this.makehash = res.parametro
              this.prefix = res.prefix
              this.timeValidate=res.paramValidateTime
            }else{
              alert(res.mensaje)
            }

          });
      } else {
        this.loading = false;
        this.dialogWarning = true;
      }
    },
    async loadInitial() {
      this.$API
        .get({
          url: "inscripcion/config",
          data: {}
        })
        .then(res => {

          // Cursos
          this.inputs[18].data = res.cursos;

          // Sedes
          this.inputs[14].data = res.sedes;

          // Temporadas
          this.inputs[17].data = res.temporadas;
          // this.inputs[17].data = this.years;

          // Meses
          this.inputs[15].data = res.meses;

          console.log("Done Info");

        });

      this.$API
        .get({
          url: "circuito/status-pago/" + this.$route.params.preinscrito,
          data: {}
        })
        .then(res => {
          if (res) {

            // if (res.ML_Estado != "Exito: Pendiente Verificar") {
            //   setTimeout(() => {
            //     this.$router.replace({ name: "CircuitoPago", params:{id:res.circuito.uuid, idML:res.SecretKeyML}});
            //   }, 2000);
            //   return;
            // }

            this.inputs[0].value = res.Nombres.replace(/ /g, "").toLowerCase() + res.Apellidos.replace(/ /g, "").toLowerCase() + "@institutoiea.edu.ar";
            this.inputs[0].readonly = true;
            this.inputs[1].value = res.Email;
            this.inputs[1].readonly = true;
            this.inputs[2].value = res.Nombres;
            this.inputs[2].readonly = true;
            this.inputs[3].value = res.Apellidos;
            this.inputs[3].readonly = true;
            this.inputs[5].value = res.tipoDoc;
            this.inputs[5].readonly = true;
            this.inputs[6].value = res.DNI;
            this.inputs[6].readonly = true;
            this.inputs[12].value = res.AreaCelular;
            this.inputs[12].readonly = true;
            this.inputs[13].value = res.TelefonoCelular;
            this.inputs[13].readonly = true;
            this.inputs[14].value = parseInt(res.curso.Sede);
            this.inputs[14].readonly = true;
            this.inputs[18].value = res.curso_id;
            this.inputs[18].readonly = true;

            console.log("Done status-pago");
          }
        })
        .catch(() => {
          this.$store.dispatch("circuito", "");
          this.$store.dispatch("preinscrito", "");
          this.$store.dispatch("inscripto", "");
          this.$router.replace({ name: "Circuito", params: { id: 123 } });
        });

      this.$API
        .get({
          url: "circuito/show/" + this.$route.params.id,
          data: {}
        })
        .then(res => {
          this.formulario = res.model.Formulario;

          // debugger;

          if (res) {

            // this.inputs[14].value =
            //   res.circuito_interes.sede_id > 0
            //     ? res.circuito_interes.sede_id
            //     : "";

            // this.inputs[14].disabled =
            //   res.circuito_interes.sede_id > 0 ? true : false;

            if (this.formulario !== "Carreras Terciarias Exterior") {

              this.inputs[21].value = "No";
            }

            if (this.formulario === "BCE Secundario Exterior" || this.formulario === "Carreras Terciarias Exterior") {
              this.inputs[8].text = "Domicilio Declarado en Argentina";
              this.inputs[8].value = "Malvinas Argentinas";

            }

            if (this.formulario == "Cursos Online Argentina" || this.formulario == "Cursos Online Exterior") {
              this.inputs[34].value = "NO";
              this.inputs[32].value = "NO";
              this.inputs[30].value = "NO";
              this.inputs[36].value = "Otro";

              this.inputs[23].value = "no aplica";
              this.inputs[24].value = "no aplica";
              this.inputs[25].value = "no aplica";
              this.inputs[26].value = "no aplica";
              this.inputs[27].value = "no aplica";
              this.inputs[28].value = "no aplica";
              this.inputs[19].value = "no aplica";
            }

            this.inputs[15].value =
              res.model.circuito_interes.set_mes_id > 0
                ? res.model.circuito_interes.set_mes_id
                : "";
            this.inputs[15].readonly =
              res.model.circuito_interes.set_mes_id > 0 ? true : false;

            this.inputs[16].value =
              res.model.circuito_interes.turno_id > 0
                ? res.model.circuito_interes.turno_id
                : "";
            this.inputs[16].readonly =
              res.model.circuito_interes.turno_id > 0 ? true : false;

            this.inputs[17].value =
              res.model.circuito_interes.temporada_id > 0
                ? res.model.circuito_interes.temporada_id
                : "";
            this.inputs[17].readonly =
              res.model.circuito_interes.temporada_id > 0 ? true : false;

            // this.inputs[18].value =
            //   res.circuito_interes.curso_id > 0
            //     ? res.circuito_interes.curso_id
            //     : "";
            // this.inputs[18].disabled =
            //   res.circuito_interes.curso_id > 0 ? true : false;
          }
        });
    }
  }
};
</script>
